import React, { useState } from "react";
import { Container } from "reactstrap";

import HyperDriveInfo from "components/HyperDrive/HyperDrive";
import WhyMagLev from "components/HyperDrive/WhyMagLev";
import RotorSystem_Conventional from "components/HyperDrive/RotorSystem_Conventional";
import RotorSystem_Ours from "components/HyperDrive/RotorSystem_Ours";
import TipDriven from "components/HyperDrive/TipDriven";
import ConceptStudy from "components/HyperDrive/ConceptStudy";
import Applications from "components/HyperDrive/Applications";
import PartnerWith from "components/HyperDrive/PartnerWith";
import { 
  BE_2024_Brochure, 
  TIDE_2024_Brochure 
} from "components/HyperDrive/Brochure";

const HyperDrive = ({event}) => {
  const [padding, setPadding] = React.useState('100px'); // Set an initial value

  document.documentElement.classList.remove("nav-open");

  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
      const width = window.innerWidth;
      let newPadding;

      if (width <= 767) {
        newPadding = '42px';
      } else if (width > 767 && width <= 991) {
        newPadding = '58px';
      } else if (width > 991 && width <= 1024) {
        newPadding = '75px';
      } else if (width > 1024 && width <= 1440) {
        newPadding = '95px';
      } else if (width > 1440 && width <= 2560) {
        newPadding = '90px';
      } else {
        newPadding = '100px'; // Default value for larger screens
      }

      setPadding(newPadding);
    };

    // Initial check on mount
    handleResize();

    // Listen to window resize events
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="main">
      <div className="section section-maglev-blue text-center">
        <Container>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            {
              event != "" ? <>
                <Event event={event}/>
                <br/>
              </> : null
            }
            <HyperDriveInfo isMobile={isMobile} padding={padding}/>
            <br/><br/>
            <RotorSystem_Conventional/>
            <br/><br/>
            <RotorSystem_Ours/>
            <br/><br/>
            <WhyMagLev isMobile={isMobile} />
            <br/>
            <TipDriven/>
            <br/><br/>
            <ConceptStudy isMobile={isMobile} />
            <br/><br/>
            <Applications/>
            <br/><br/>
            <PartnerWith/>
          </div>
        </Container>
      </div>
    </div>
  );
}

const Event = ({event}) => {
  switch(event) {
    case 'be2024':
      return <BE_2024_Brochure/>;
    case 'tide2024':
      return <TIDE_2024_Brochure/>;
    default:
      return null;
  }
}

export default HyperDrive;
